import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { LoginService } from "../login.service";
import { ExamsService } from "../exams.service";
import { PatientsService } from "../patients.service";
import { Patient } from "../patients/patient";
import { Subject, Subscription } from "rxjs";
import * as XLSX from "xlsx";
import { takeUntil } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { SitesService } from "../sites.service";

@Component({
    selector: "app-docpanel",
    templateUrl: "./docpanel.component.html",
    styleUrls: ["./docpanel.component.scss"],
    standalone: false
})
export class DocpanelComponent implements OnInit, OnDestroy {
  // Switching clinics mid-exam is dangerous (the exam is already tied to a
  // specific clinic/session) — examsbar sets this to hide the switcher there.
  @Input() disableSiteSwitch = false;
  showLogin = false;
  sub = new Subscription();
  private destroy$ = new Subject();
  showLimits = false;

  constructor(
    private http: HttpClient,
    public loginService: LoginService,
    public patS: PatientsService,
    private es: ExamsService,
    public sites: SitesService,
  ) {}

  ngOnInit() {
    this.sub = this.loginService.export$
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        if (data) {
          this.export(data);
        }
      });
    // Global clinic switcher: load once here so it's ready regardless of which
    // page the doctor lands on first (not just the TodayList).
    this.sites.loadSites();
  }

  onSiteSwitch(value: number | "all") {
    this.sites.setActiveSite(value);
  }

  goDefaults() {
    let defaults = new Patient("default", "default", "defaults", "defaults");
    defaults.PID = 0;
    this.patS.setPat(defaults, true);
  }

  // Redirect into the admin app (awebAppointments) for the given module — mirrors
  // patients.component.ts. Moved here so the questionnaires entry lives in Settings.
  redirectAdministration(type) {
    this.http.post("/api/administration", { type }).subscribe((data: string) => {
      window.location.href = data;
    });
  }

  export(res) {
    this.sub = res.subscribe((data) => {
      var element = document.createElement("a");
      // window.open('/api/stats/exportData')
      element.setAttribute("href", "/api/stats/readydata");
      element.setAttribute("download", "./test.csv");
      document.body.appendChild(element);
      element.click();
      setTimeout(() => {
        document.body.removeChild(element);
      }, 4000);

      this.loginService.exportLoading = false;
      this.showLogin = false;
    });
  }

  logout() {
    this.sites.reset(); // clear site cache so the next user doesn't inherit cross-clinic mode
    this.loginService.clearCookies();
    this.loginService.Logout();
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
    this.destroy$.next(undefined);
  }
}
